import PropTypes from 'prop-types';
import {Modal} from '@/components/atoms';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';
import {useAddRackModal} from '@/hooks/useAddRackModal';
import RackModalForm from './RackModalForm';
import './addRackModal.scss';

const AddRackModal = ({onClose, onPublished}) => {
  const hook = useAddRackModal({onSuccess: onPublished || onClose});
  const {isPublishing, canPublish, handlePublish} = hook;

  const handleClose = () => {
    if (!isPublishing) onClose();
  };

  return (
    <Modal
      id='add-rack'
      type={MODAL_TYPE.SMALL}
      showModal
      title='Add Rack'
      isDark
      hideCloseButton
      className='addRackModal'
      primaryButtonText={isPublishing ? 'Publishing...' : 'Done'}
      secondaryButtonText='Cancel'
      primaryButtonProps={{'aria-label': 'Done'}}
      secondaryButtonProps={{'aria-label': 'Cancel'}}
      showSecondaryButton
      secondaryButtonDisabled={isPublishing}
      primaryButtonDisabled={!canPublish}
      onCloseModal={handleClose}
      onClickSecondaryButton={handleClose}
      onClickPrimaryButton={handlePublish}
      content={
        <RackModalForm idPrefix='add-rack' isBusy={isPublishing} {...hook} />
      }
    />
  );
};

AddRackModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onPublished: PropTypes.func
};

export default AddRackModal;
